import styled from "styled-components";
import {useState} from "react";
import Page, { PageContent } from "../models/page";
import {nanoid} from "nanoid";
import ContentToComponent from "../utils/content-to-component";
import AddContentModal from "../views/add-content-modal";

const SubTopBar = styled.div`
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  height: 60px;
  border-bottom: 1px solid #f0f0f0;
  background: white;
`;
const TopBarContent = styled.div`
  max-width: 1000px;
  margin: auto;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const TitleInput = styled.input`
  appearance: none;
  border: none;
  font-size: 2rem;
  font-weight: bold;
  color: black;
  &::placeholder {
    color: rgb(200,200,200);
  }
  &:focus {
    outline: none;
  }
`;

const ToggleCircle = styled.div`
  position: absolute;
  top: 2px;
  height: 35px;
  width: 35px;
  border-radius: 18px;
  background: white;
  transition: .25s;
`;

const ToggleWrapper = styled.div`
  margin-left: 1rem;
  position: relative;
  height: 39px;
  width: 70px;
  border-radius: 20px;
  cursor: pointer;
  background-color: ${(props: {value: boolean}) => props.value ? "#95ffd1" : "#EEEEEE"};
  transition: .25s;
  ${ToggleCircle} {
    left: ${props => props.value ? "33" : "2"}px;
  }
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  font-size: 1.2rem;
  font-weight: 600;
`;

const EmptyContainer = styled.div`
  position: relative;
  margin: 1rem 0;
  border-radius: 12px;
  border: 1px solid #EEEEEE;
  color: #949494;
  padding: 1rem;
  transition: .15s;
  background: transparent;
  cursor: pointer;
  font-weight: bold;
  font-size: 1.2rem;
  &::after {
    position: absolute;
    content: "+";
    font-size: 2rem;
    font-weight: bold;
    color: transparent;
    border-radius: 12px;
    background: transparent;
    transition: .15s;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  &:hover {
    background: white;
  }
  &:hover&::after {
    background: white;
    color: black;
  }
`;

function Toggle(props: {value: boolean, onClick: () => void, label: string}) {

    return <Container>
        {props.label}
        <ToggleWrapper {...props}>
            <ToggleCircle />
        </ToggleWrapper>
    </Container>
}

export default function CreatePageScreen() {
    const [page, setPage] = useState<Page>({
        id: nanoid(6),
        title: "",
        handle: "",
        pageId: 0,
        content: [],
        published: false,
    });
    const [activeIndex, setActiveIndex] = useState(0);

    const onAddContent = (c: PageContent) => {
      let content = [...page.content];
      content.splice(activeIndex, 0, c);
      setPage(p => ({...p, content}));
    };

    const [showContentModal, setShowContentModal] = useState(false);

    return <>
        {!!page && <SubTopBar>
            <TopBarContent>
                <TitleInput placeholder="Titel..."/>
                <Toggle
                  value={page.published}
                  onClick={() => setPage(p => ({...p, published: !p.published}))}
                  label="Veröffentlicht?"/>
            </TopBarContent>
        </SubTopBar>}
        <div style={{height: "70px"}} />
        {page.content.map((c, i) => <ContentToComponent pageState={[page, setPage]} content={c} index={i} />)}
        {page.content.length === 0 && <EmptyContainer onClick={() => {
          setActiveIndex(0);
          setShowContentModal(true);
        }}>
          Klicke hier, um Inhalt hinzuzufügen
        </EmptyContainer>}
        {!!page && showContentModal
          && <AddContentModal addContent={(c) => onAddContent(c)} close={() => setShowContentModal(false)} />}
    </>
}